export enum OfficeLocation {
  Geneva = 'Geneva',
  HongKong = 'HongKong',
  London = 'London'
}
